// Small hand-authored line icons for the audience/garment segmented
// selectors — inline SVG, no icon library or external assets.
import type { SVGProps } from 'react';

function Icon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={`h-4 w-4 ${className ?? ''}`}
      {...props}
    />
  );
}

/** One generic person icon for every audience option — the label text (Women/Men/Youth) carries the distinction, not the icon shape. */
export function PersonIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <circle cx="10" cy="6.3" r="3" />
      <path d="M4 17c.8-3.2 3.4-5 6-5s5.2 1.8 6 5" />
    </Icon>
  );
}

export function TopGarmentIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M7 3.5 4 6l1.5 2.5L7 7.5V17h6V7.5l1.5 1 1.5-2.5-3-2.5c-.5.8-1.4 1.3-3 1.3s-2.5-.5-3-1.3Z" />
    </Icon>
  );
}

export function BottomGarmentIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <Icon {...props}>
      <path d="M6.5 3h7l.5 6.5.8 7.5h-3l-.9-8-.9 8h-3l.8-7.5Z" />
    </Icon>
  );
}
